// stores
import auth from "AurionCR/store/modules/auth"
import notify from "AurionCR/store/modules/notify"
import routes from "AurionCR/store/modules/routes"
import sources from "AurionCR/store/modules/sources"
import language from "AurionCR/store/modules/language"
// sagas
import authSaga from "AurionCR/store/sagas/auth"
import sourceSaga from "AurionCR/store/sagas/source"

import {
  Action,
  combineReducers,
  configureStore,
  ThunkAction,
} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { all } from 'redux-saga/effects';
import { apiRtk } from 'utils/api-rtk';



const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
  auth,
  notify,
  routes,
  sources,
  language,

  [apiRtk.reducerPath]: apiRtk.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
    })
      .concat(sagaMiddleware)
      .concat(apiRtk.middleware),
  devTools: import.meta.env.DEV,
  
});

function* rootSaga() {
  yield all([
    ...authSaga,
    ...sourceSaga,
  ]);
}

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  AppState,
  unknown,
  Action<string>
>;
export type AppAsyncThunkConfig = {
  state: AppState;
  dispatch: AppDispatch;
  serializedErrorType: Error;
};
